import React, {Component, Fragment} from 'react';
import Header from "../Layouts/Header";
import Footer from "../Layouts/Footer";
import Products from "./Home/Products";

const AboutUs = (props) => {
    return (
        <Fragment>
            <div className="mkdf-wrapper">
                <div className="mkdf-wrapper-inner">
                    <Header/>
                    <div className="mkdf-content">
                        <div className="mkdf-content-inner">
                            <div className="mkdf-full-width" style={{minHeight: 'calc(100vh - 60px)'}}>
                                <AboutUsContent/>
                            </div>
                        </div>
                    </div>
                    <Footer/>
                </div>
            </div>
        </Fragment>
    );
};
const AboutUsContent = props => {
    return (
        <div className="mkdf-content">
            <div className="mkdf-content-inner">
                <div className="mkdf-full-width" style={{minHeight: 'calc(100vh - 60px)'}}>
                    <div className="mkdf-full-width-inner">
                        <div className="mkdf-grid-row">
                            <div className="mkdf-page-content-holder mkdf-grid-col-12">
                                <div className="mkdf-row-grid-section-wrapper mkdf-disabled-bg-image-bellow-768">
                                    <div className="mkdf-row-grid-section">
                                        <div className="vc_row wpb_row vc_row-fluid vc_custom_1528888583995 vc_row-has-fill">
                                            <div className="wpb_column vc_column_container vc_col-sm-12">
                                                <div className="vc_column-inner">
                                                    <div className="about-us">
                                                        <h1>Our Vision</h1>
                                                        <p>To have an ambitious leading generation to help in the growth of the Canadian and QuÈbec society.</p>

                                                        <h1>Our objectives</h1>
                                                        <ul>
                                                            <li>To help children integrate into Quebec and Canadian society.</li>
                                                            <li>To create a welcoming environment for newcomers.</li>
                                                            <li>To help children to overcome the hardships and find solutions to all their problems and learn to express themselves better.</li>
                                                            <li>To help children to communicate better with each other.</li>
                                                            <li>To help children gain confidence in themselves and develop their self-esteem.</li>
                                                            <li>To create a healthy environment and raise awareness of the importance of education.</li>
                                                            <li>To create fun and educational activities for kids.</li>
                                                        </ul>
                                                        <h1>Our Values</h1>
                                                        <ul>
                                                            <li><span>C</span>= Creativity</li>
                                                            <li><span>R</span>= Resilience</li>
                                                            <li><span>O</span>= Optimisim</li>
                                                            <li><span>W</span>= Wisdom</li>
                                                            <li><span>N</span>= Noble</li>
                                                            <li><span>S</span>= Self-Assurance</li>
                                                        </ul>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mkdf-content-bottom">
                    <div className="mkdf-content-bottom-inner mkdf-full-width">
                        <div className="widget widget_mkdf_instagram_widget"/>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default AboutUs;
